import { render, staticRenderFns } from "./postalCodeFormInput.vue?vue&type=template&id=ca2a8dc6&"
import script from "./postalCodeFormInput.vue?vue&type=script&lang=js&"
export * from "./postalCodeFormInput.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports